import { useLayoutEffect, useRef } from "react";
import { Grommet, Box } from "grommet";
import { appTheme } from "../theme";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { GlobalHeader } from "../components";
import { ChatWidget } from "../components/chat";
import { useThemeMode } from "../components/theme";
import {
	Dashboard,
	LoginPage,
	LandingPage,
	HelpPage,
	Demo,
	StorageCalendar,
	PageNotFound,
	ProductGroup,
	AdminDashboard,
	AdminDataManager
} from "../pages";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import CompetitorDashboard from "../pages/CompetitorDashboard";
import CompetitorProductListPage from "../pages/CompetitorProductListPage";
import CompetitorBattleCards from "../pages/CompetitorBattleCards";
import CompetitorReportPage from "../pages/CompetitorReportPage";
import backgroud_img from "../static/svg/bg_img.svg"
import NotificationCenter from "../pages/NotificationCenter";
import StorageDashboard from "../pages/StorageApplicationMainPage";
import ApplicationPrimaryListPage from "../pages/StoragePrimariesPage";
import StorageSecondaryPage from "../pages/StorageSecondaryPage";
import StorageAdminDashboard from "../pages/StorageAdminDashboard";
import { AdminUserFeedback } from "../pages/AdminUserFeedbackPage";
import { AdminAnnouncementsPage } from "../pages/AdminAnnouncementsPage";
import { AnnouncementBanner } from "../components/announcements/AnnouncementBanner";
import { StorageAdminDataManager } from "../pages/StorageAdminDataManager";

// moves the static #header/#footer from index.html (already filled by HFWS) into the layout
const HfwsSlot = ({ id }) => {
	const ref = useRef(null);
	useLayoutEffect(() => {
		const el = document.getElementById(id);
		const container = ref.current;
		if (!el || !container) return undefined;
		container.appendChild(el);
		return () => document.body.appendChild(el);
	}, [id]);
	return <div ref={ref} />;
};

export const PrivateLayout = ({ authenticate, checked }) => {
	const { themeMode } = useThemeMode();
	return (
		<Grommet theme={appTheme} themeMode={themeMode} full>
			<Box style={{ minHeight: "100vh" }}>
				<Box flex={false}>
					<HfwsSlot id='header' />
					{checked && <GlobalHeader />}
				</Box>
				{checked && <AnnouncementBanner />}
				<Box
					flex='grow'
					background={themeMode === "dark" ? "background" : { image: `url(${backgroud_img})`, size: "cover", position: "center" }}
				>
					<Box
						flex='grow'
						justify='start'
						fill='horizontal'
						margin={{ horizontal: "auto" }}
						width={{ max: "1800px" }}
					>
						{checked && (
							<>
								<Switch>
									<Route path='/index' component={LandingPage} />
									<Route path='/login' component={LoginPage} />
									<PrivateRoute exact path='/' component={StorageDashboard} />
									<PrivateRoute exact path='/dashboard' component={Dashboard} />
									<PrivateRoute exact path='/calendar' component={StorageCalendar} />
									<PrivateRoute exact path='/product-group/:id' component={ProductGroup} />
									<PrivateRoute exact path='/product-group/:product_group_id/demo/:id' component={Demo} />
									<PrivateRoute exact path='/:product_group_id/demo/:id' component={Demo} />
									<PrivateRoute exact path='/learn-more' component={HelpPage} />
									<PrivateRoute exact path='/competitor' component={CompetitorDashboard} />
									<PrivateRoute exact path='/competitor/:id' component={CompetitorProductListPage} />
									<PrivateRoute exact path='/tools/:id&:name' component={CompetitorProductListPage} />
									{/* <PrivateRoute exact path='/competitor/:id/:product_id/resource-center' component={CompetitorResourceCenter} /> */}
									<PrivateRoute exact path='/competitor/:id/:product_id/resource-center/:res_id' component={CompetitorBattleCards} />
									<PrivateRoute exact path="/notification-center" component={NotificationCenter} />
									<PrivateRoute exact path='/competitor/admin-report' component={CompetitorReportPage} />
									<PrivateRoute exact path='/admin-dash' component={AdminDashboard} />
									<PrivateRoute exact path='/admin-user-feedback' component={AdminUserFeedback} />
									<PrivateRoute exact path='/admin-announcements' component={AdminAnnouncementsPage} />
									<PrivateRoute exact path='/storage-admin-dash/:id' component={StorageAdminDashboard} />
									<PrivateRoute exact path='/admin-manager' component={AdminDataManager} />
									<PrivateRoute exact path='/storage-admin-manager/:id' component={StorageAdminDataManager} />
									<PrivateRoute exact path='/storage' component={StorageDashboard} />
									<PrivateRoute exact path='/storage/:id' component={ApplicationPrimaryListPage} />
									<PrivateRoute exact path='/storage/:id/secondary/:primary_id' component={StorageSecondaryPage} />
									<Route component={PageNotFound} />
								</Switch>
								<ChatWidget />
							</>
						)}
					</Box>
				</Box>
				<Box flex={false}>
					<HfwsSlot id='footer' />
				</Box>
			</Box>
		</Grommet>
	);
};

const { bool } = PropTypes;

PrivateLayout.propTypes = {
	authenticated: bool.isRequired,
	checked: bool.isRequired,
};

const mapState = ({ session }) => ({
	checked: session.checked,
	authenticated: session.authenticated,
});

export default connect(mapState)(PrivateLayout);
